/**
 * House of Places — open the header mega menu on hover.
 *
 * Dawn drives <details> from clicks only. The reference nav opens on hover, so
 * pointer intent is added on top rather than replacing the click: the summary
 * still toggles, Escape still closes, and keyboard focus still works, because
 * all of that lives on the same `open` attribute this file sets.
 *
 * Only real hover devices get it. A touch device reports `hover: none`, where
 * a hover handler would fire on first tap and swallow it — there the click
 * behaviour Dawn ships is the correct one and this script stays out.
 */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var KAPANMA_GECIKMESI = 180;

  // The Shop panel and the search open the same way, so they share the same
  // behaviour. The search sits in .header__search; its own <details> is what
  // Dawn toggles on click, and hover just drives the same attribute.
  var acilirlar = [].concat(
    Array.prototype.slice.call(document.querySelectorAll('.hop-mega')),
    Array.prototype.slice.call(document.querySelectorAll('.header__search > details')),
  );

  acilirlar.forEach(function (details) {
    var menu = details.closest('header-menu') || details.closest('.header__search') || details;
    var zamanlayici = null;

    function ac() {
      clearTimeout(zamanlayici);
      if (details.open) return;
      // One panel at a time. An open search held on (focus inside keeps it
      // open) while hovering Shop opened the mega panel under it — both start
      // at the header's bottom edge, so the search bar covered the panel's
      // headings. The search closes through Dawn's details-modal so its
      // focus trap and body lock are released too.
      acilirlar.forEach(function (diger) {
        if (diger === details || !diger.open) return;
        var modal = diger.closest('details-modal');
        if (modal && typeof modal.close === 'function') {
          modal.close(false);
        } else {
          diger.open = false;
          diger.dispatchEvent(new Event('toggle'));
        }
      });
      details.open = true;
      // Dawn listens for toggle to record the header's bottom edge, which the
      // panel's max-height depends on.
      details.dispatchEvent(new Event('toggle'));
    }

    function kapat() {
      if (!details.open) return;
      // Never yank the panel out from under a keyboard user inside it.
      if (details.contains(document.activeElement)) return;
      details.open = false;
      details.dispatchEvent(new Event('toggle'));
    }

    function gecikmeliKapat() {
      clearTimeout(zamanlayici);
      zamanlayici = setTimeout(kapat, KAPANMA_GECIKMESI);
    }

    menu.addEventListener('mouseenter', ac);
    menu.addEventListener('mouseleave', gecikmeliKapat);

    // Clicking the label goes to the page it stands for. A <summary> cannot
    // be a link, and its default click toggles the panel — which is exactly
    // what a keyboard user needs. So only a real pointer click navigates
    // (detail > 0); Enter and Space leave detail at 0 and still toggle.
    var ozet = details.querySelector('summary[data-hop-shop-url]');
    if (ozet) {
      ozet.addEventListener('click', function (e) {
        if (e.detail === 0) return;
        e.preventDefault();
        window.location.href = ozet.getAttribute('data-hop-shop-url');
      });
    }

    // The panel is full-bleed and starts below the header, so the pointer
    // leaves the summary to reach it. Keep it open while it is inside.
    var panel = details.querySelector('.mega-menu__content, .search-modal');
    if (panel) {
      panel.addEventListener('mouseenter', ac);
      panel.addEventListener('mouseleave', gecikmeliKapat);
    }
  });
})();
